"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var React = require('react');
var PropTypes = require('prop-types');
var ProgressBarPlugin = require('@uppy/progress-bar');
var uppyPropType = require('./propTypes').uppy;
var getHTMLProps = require('./getHTMLProps');
var nonHtmlPropsHaveChanged = require('./nonHtmlPropsHaveChanged');
var h = React.createElement;
/**
 * React component that renders a progress bar at the top of the page.
 */ var ProgressBar = /*#__PURE__*/ function(_React_Component) {
    _inherits(ProgressBar, _React_Component);
    function ProgressBar() {
        _class_call_check(this, ProgressBar);
        return _call_super(this, ProgressBar, arguments);
    }
    _create_class(ProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.installPlugin();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.uppy !== this.props.uppy) {
                    this.uninstallPlugin(prevProps);
                    this.installPlugin();
                } else if (nonHtmlPropsHaveChanged(this, prevProps)) {
                    var options = _object_spread_props(_object_spread({}, this.props), {
                        target: this.container
                    });
                    delete options.uppy;
                    this.plugin.setOptions(options);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.uninstallPlugin();
            }
        },
        {
            key: "installPlugin",
            value: function installPlugin() {
                var uppy = this.props.uppy;
                var options = _object_spread_props(_object_spread({
                    id: 'react:ProgressBar'
                }, this.props), {
                    target: this.container
                });
                delete options.uppy;
                uppy.use(ProgressBarPlugin, options);
                this.plugin = uppy.getPlugin(options.id);
            }
        },
        {
            key: "uninstallPlugin",
            value: function uninstallPlugin(props) {
                if (props === void 0) {
                    props = this.props;
                }
                var uppy = props.uppy;
                uppy.removePlugin(this.plugin);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
                this.validProps = getHTMLProps(this.props);
                return h('div', _object_spread({
                    ref: function(container) {
                        _this.container = container;
                    }
                }, this.validProps));
            }
        }
    ]);
    return ProgressBar;
}(React.Component);
ProgressBar.propTypes = {
    uppy: uppyPropType,
    fixed: PropTypes.bool,
    hideAfterFinish: PropTypes.bool
};
ProgressBar.defaultProps = {};
module.exports = ProgressBar;
